import { render, staticRenderFns } from "./inventoryMove.vue?vue&type=template&id=04a87555&scoped=true"
import script from "./inventoryMove.vue?vue&type=script&lang=js"
export * from "./inventoryMove.vue?vue&type=script&lang=js"
import style0 from "./inventoryMove.vue?vue&type=style&index=0&id=04a87555&prod&style=true&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a87555",
  null
  
)

export default component.exports